import { SVGProps, Ref, forwardRef } from 'react';

export const AUSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M28.444 4H3.556q-.274 0-.537.042L3.015 5.66.588 5.657A3.8 3.8 0 0 0 0 7.692v16.616C0 26.347 1.592 28 3.556 28h24.888C30.408 28 32 26.347 32 24.308V7.692C32 5.653 30.408 4 28.444 4"
            fill="#00247D"
        />
        <path
            d="m8 23.406-1.086 1.042.107-1.532-1.462-.232 1.22-.868-.736-1.332 1.414.45.543-1.43.544 1.43 1.414-.45-.738 1.332 1.222.868-1.462.232.107 1.532zM24.844 8.21l-.71.681.07-1.002-.957-.152.8-.567-.483-.872.925.295.355-.935.357.935.925-.295-.482.872.798.567-.957.152.07 1.002zM21.29 13.75l-.71.683.07-1.003-.957-.151.799-.569-.482-.871.924.294.356-.935.356.935.926-.294-.483.871.798.569-.956.151.07 1.003zm8-1.846-.71.682.07-1.002-.957-.151.799-.569-.482-.871.924.294.356-.935.356.935.926-.294-.483.871.798.569-.956.151.07 1.002zm-4.445 12.923-.71.683.07-1.003-.957-.151.8-.569-.483-.871.925.294.355-.935.357.935.925-.294-.482.871.798.569-.957.151.07 1.003zm2.712-10.672.26.55.585.088-.422.427.1.605-.523-.285-.523.285.1-.605-.423-.427.584-.088z"
            fill="white"
        />
        <path
            d="M16.889 16V4H3.556c-.285 0-.537.042-.537.042L3.015 5.66.588 5.657s-.037.054-.112.19A3.8 3.8 0 0 0 0 7.691V16z"
            fill="#00247D"
        />
        <path
            d="M16.889 4h-2.072l-4.15 3.018V4H6.222v2.371L3.02 4.041c-.546.087-1.058.3-1.487.614l4.18 3.037H4.169L.859 5.284q-.146.178-.27.373l2.8 2.035H0v4.616h3.453L0 14.86V16h2.962l3.26-2.37V16h4.445v-3.017L14.816 16h2.073v-1.873l-2.502-1.82h2.502V7.693h-2.501l2.5-1.82z"
            fill="#EEEEEE"
        />
        <path d="M9.778 4H7.11v4.615H0v2.77h7.111V16h2.667v-4.615h7.11v-2.77h-7.11z" fill="#CF1B2B" />
        <path
            d="M16.889 4H15.59l-4.923 3.58v.112h1.396l4.826-3.51zm-15.357.655q-.375.27-.672.629l3.309 2.408H5.71zm4.19 7.653L.652 16h1.536l4.034-2.934v-.758zm11.167 3.51V14.69l-3.277-2.383h-1.55z"
            fill="#CF1B2B"
        />
    </svg>
));
AUSize32Glyph.displayName = 'AUSize32Glyph';
